import { SCORE } from '@accra/shared';
import type { EventBus } from '../../core/events';
import type { RunState } from '../../game/RunState';
import { addBonus } from '../scoring';
import { isActive, startPowerUp } from './powerUps';
import { collectGift, collectStar } from './roadBonuses';

const MAGNET_RANGE = 12;
const MAGNET_PULL = 22;
const REACH_X = 0.5;

/** Picks up coins, crates, stars and gifts the trotro drives through. Under the magnet, coins fly to the trotro. */
export function collectPickups(state: RunState, dt: number, events: EventBus): void {
  const { bus } = state;
  const magnet = isActive(state, 'magnet');
  const keep = [];
  for (const pickup of state.pickups) {
    if (magnet && pickup.kind === 'coin' && Math.abs(pickup.s - bus.s) < MAGNET_RANGE) {
      const step = MAGNET_PULL * dt;
      pickup.x += Math.sign(bus.x - pickup.x) * Math.min(step, Math.abs(bus.x - pickup.x));
      pickup.s += Math.sign(bus.s - pickup.s) * Math.min(step * 0.6, Math.abs(bus.s - pickup.s));
    }
    const touching =
      Math.abs(pickup.s - bus.s) < bus.size.length / 2 + 0.4 &&
      Math.abs(pickup.x - bus.x) < bus.size.width / 2 + REACH_X &&
      bus.y < pickup.y + 1.5;
    if (!touching) {
      keep.push(pickup);
      continue;
    }
    if (pickup.kind === 'coin') {
      state.stats.coins += 1;
      addBonus(state, SCORE.perCoin);
      events.emit('pickup:coin', { total: state.stats.coins });
    } else if (pickup.kind === 'star' && pickup.factor) {
      collectStar(state, pickup.factor, events);
    } else if (pickup.kind === 'gift' && pickup.gift) {
      collectGift(state, pickup.gift, events);
    } else if (pickup.power) {
      startPowerUp(state, pickup.power, events);
    }
  }
  state.pickups = keep;
}
